import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, RouterModule } from '@angular/router';
import { LoaderService } from 'src/app/service/loader.service';
import { RestService } from 'src/app/service/rest.service';
import { MatDialogComponent } from '../../dialog-box/mat-dialog/mat-dialog.component';
import { CommonService } from 'src/app/service/common.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MyProfileService } from 'src/app/service/user-details.service';
import { MenuIdService } from 'src/app/service/menu-id.service';
import { Observable } from 'rxjs';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { SimulationDataService } from 'src/app/service/simulation-data.service';
import { LOBproductConfigEnum } from 'src/app/enums/lob.enum';
import { MobileLoginDialogComponent } from '../../dialog-box/swiftAntB2C/mobile-login-dialog/mobile-login-dialog.component';
import { AuthService } from 'src/app/core/auth.service';
import { SignUpComponent } from '../sign-up/sign-up.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-new-menu',
  templateUrl: './new-menu.component.html',
  styleUrls: ['./new-menu.component.scss'],
  standalone:true,
  imports:[
    MatButtonModule,
    TranslateModule,CommonModule,CommonModule,MatMenuModule,RouterModule,
  ]
})
export class NewMenuComponent implements OnInit {

  isMouseInsideMenu: boolean = false;
  showSearch = false;
  searchText: string = '';
  language: string = '';
  menuToCreate: any[] = [];
  menuToView: any[] = [];
  menuArray: any;
  userDetail: any;
  firstName = '';
  orgName!: string | null;
  orgGrpId: any = [];
  subMenu = false;
  menuSubModules: any[] = [];
  modules: any[] = [];
  mainModule: any;
  activeMenu: boolean = false;
  activeModule: any[] = [];
  subModule: any;
  breadcrumbHistory: any[] = [];
  imageURL!:Observable<string>;
  LOBEnum : any=LOBproductConfigEnum;


  
  renewProducts=[
    { value: 'life', viewValue: 'Life Renewal' },
    { value: 'motr', viewValue: 'Motor Renewal' },
  ]
  claimProducts=[
    { value: 'claim', viewValue: 'New Claim' },

  ]
  supportProducts=[
    { value: 'help', viewValue: 'Help Document' },

  ]
  lineOfBusinesses:any=[];
  categories:any=[];
  categoriesUpdated:any=[];
  finalMaster:any=[];
  // @Input() isLogin:any;
  isLogin:any;
  hidemenutag:any;
  languages : any[] = [
    { title : 'English' , value : 'en'},
    { title : 'Amharic' , value : 'am'}
  ]
  @Output() changedLanguage = new EventEmitter<any>()
  userDetails: any;
  isExistingCustomer: any;
  @Input() logoPath;
  constructor(private router: Router,
    public menuIdService:MenuIdService,
    private restService: RestService, private dialog: MatDialog, private loader: LoaderService,private SimulationDataService:SimulationDataService,
    private commonService: CommonService, private translate: TranslateService, private myProfileService: MyProfileService,private authService:AuthService) { }


  ngOnInit(): void {
    this.authService.isLoggedIn.subscribe(status => {
      this.isLogin = status;
      
    });
   console.log(this.logoPath)

    // setInterval(()=>{
    //   this.isLogin=localStorage.getItem('Afrisure-Token')

    // },1000)

    this.imageURL = this.menuIdService.getActiveImageURL();
    // console.log( this.imageURL,'img');
    
  // this.getMenuData();

    //  this.getMasterData();
    this.getLOB();
    if(this.isLogin){
      //this.getUser();
    }
  }
  getUser() {
    let userParams = {
     
    }
    // this.restService.postUATData(userParams, 'api/digital/core/User/GetUserByUserID').subscribe({
    this.restService.postUATData(userParams, 'api/digital/core/CRM/InsertB2CCRM').subscribe({
      next: (data) => {
        if (data.rcode === 200) {
          this.userDetails = data.rObj.getAccountRetailInsertDetails;
          this.isExistingCustomer = data.rObj.isExistingCustomer
          this.loader.hide();
        }
        else {
          this.loader.hide();
          let a = data.rmsg[0].errorCode ?? 'ERROR'
          let err = this.translate.instant(a)
          const dialogRef = this.dialog.open(MatDialogComponent, {
            panelClass: ['dialog-responsive'],
            disableClose: true,
            data: { error: true, trnID: data.rObj.transactionRefNum, errorMessage: err }
          });
          dialogRef.afterClosed().subscribe();
        }
      },
      error: (error) => {
        if (error.error.rcode != 401 && error.error.rcode != 403
          && error.error.rcode != 404 && error.error.rcode != 500) {
          this.loader.hide();
          let a = error.error.rmsg[0].errorCode ?? 'ERROR'
          let err = this.translate.instant(a)
          const dialogRef = this.dialog.open(MatDialogComponent, {
            panelClass: ['dialog-responsive'],
            disableClose: true,
            data: { error: true, trnID: error.error.trnID, errorMessage: err }
          });
          dialogRef.afterClosed().subscribe();
        }
      },
    });
  }
  changeLanguage(lang: string) {
    this.changedLanguage.emit(lang)
  }
  getLOB(): void {
    const url = 'api/admin/Quotation/GetAllLOB';
    // this.loader.show();
    this.restService.postCoreBaseData({}, url).subscribe(
      {
        next: (data: any) => {
          if (data.rcode === 200) {
            // this.loader.hide();
            this.finalMaster = data.rObj.getAllLOB;
          } else {
            // this.loader.hide();
            this.commonService.handleRcodeError(data);
          }
        },
        error: (error) => {
          if (error.rcode != 200) {
            this.loader.hide();
            this.loader.hide();
            this.commonService.handleStatusError(error);
            console.error(error)
          }
        }
      });
  }
  isMobileScreen(): boolean {
    return window.innerWidth < 768; // Change the threshold as per your requirement
  }

  getMenuData() {
    this.restService.postUATData(null, 'api/digital/core/Module/FetchAllModulesforLogedinRole').subscribe(
      {
        next: (data) => {
          if (data.rcode === 200) {
            this.modules = data.rObj.modulesforRole;
            if (this.modules?.length > 0) {
              //this.menuToView = this.modules;
              // this.menuToView = this.modules.filter((module: any) => !module.isFunctionality && module.parentModuleID === null && module.url === null);
              // Assuming 'menuToView' is your array of main modules
              const menuToView = this.modules.filter((module: any) => !module.isFunctionality && module.parentModuleID === null && module.url === null);

              // Function to get sub-modules for a given main module
              const getSubModules = (mainModule: any) =>
                this.modules.filter((module: any) => !module.isFunctionality && module.parentModuleID === mainModule.sWAModuleID && module.url === null);

              // Function to get direct functionality modules for a given main module
              const getDirectFunctionalityModules = (mainModule: any) =>
                this.modules.filter((module: any) => module.isFunctionality && module.parentModuleID === mainModule.sWAModuleID && module.url !== null);

              // Function to get functionality items for a given submodule
              const getFunctionalityItems = (subModule: any) =>
                this.modules.filter((module: any) => module.isFunctionality && module.parentModuleID === subModule.sWAModuleID && module.url !== null);

              // Map main modules and add sub-modules, direct functionality modules, and functionality items
              const hierarchicalModules = menuToView.map(mainModule => ({
                ...mainModule,
                subModules: getSubModules(mainModule).map(subModule => ({
                  ...subModule,
                  functionalityItems: getFunctionalityItems(subModule)
                })),
                activeModules: getDirectFunctionalityModules(mainModule)
              }));

              // Use the 'hierarchicalModules' array based on your specific requirements
              // console.log(hierarchicalModules);
              this.menuToView = hierarchicalModules;

            }
            this.userDetail = data.rObj.userDetails;
            this.SimulationDataService.setData(this.userDetail)
          } else {
            let a = data?.rmsg[0].errorCode ?? 'ERROR'
            let err = this.translate.instant(a)
            console.error('Error Receiving data:', data);
            const dialogRef = this.dialog.open(MatDialogComponent, {
              panelClass: ['dialog-responsive'],
              disableClose: true,
              data: { error: true, trnID: data.rObj.transactionRefNum, errorMessage: err }
            });
            dialogRef.afterClosed().subscribe();
          }
        },
        error: (error) => {
          if (
            error.error.rcode !== 401 &&
            error.error.rcode !== 403 &&
            error.error.rcode !== 404 &&
            error.error.rcode !== 500
          ) {
            this.commonService.handleStatusError(error);
          }
        }
      }
    );
  }

  getMasterData() {
    // this.isOnLoadAPI = false;
    let params = {
      "functionalClassification": 50010,
      "parentMasterDataID": null
    }
    this.loader.show();
    this.restService.postCoreBaseData(params, 'api/customer/MasterData/FetchAllMaster').subscribe(
      {
        next: (data: any) => {
          if (data.rcode == 200) {
            let masterData: any = data.rObj.fetchMasterData;
            this.lineOfBusinesses = masterData.filter(item => item.mdCategoryID === 120);
            this.categories = masterData.filter(item => item.mdCategoryID === 140);
            this.lineOfBusinesses.forEach(lineOfBusiness => {
              // Filter categories for the current line of business
              const subCategories = this.categories.filter(category => category.parentMasterDataID === lineOfBusiness.masterDataID);
              
              // Check if subCategories exist for the current line of business
              if (subCategories.length > 0) {
                // Assign line of business and its sub-categories to finalMaster
              var oneval= {...lineOfBusiness,subCategories: subCategories
                }
                
              }
              if(oneval){
              this.finalMaster.push(oneval);
              }
            });
            
             
            // console.log(this.finalMaster,'finval');
             
            // this.loader.hide();
          }
          else {
            this.commonService.handleRcodeError(data);
            this.loader.hide();
          }
          // this.isOnLoadAPI = true;
        },
        error: (error: any) => {
          // this.isOnLoadAPI = true;
          this.loader.hide();
          this.commonService.checkStatusErrors(error)
        }
      })
  }
  onLOBChange(category: any) {
    this.categoriesUpdated=[]
    this.categoriesUpdated = this.categories.filter(item => (item.mdCategoryID === 140 && item.parentMasterDataID === category.masterDataID));
    // console.log(this.categoriesUpdated);
    
}
lobProduct(LOBID:string,product:any){
  const currentUrl = this.router.url; // Get the current URL
  this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    this.router.navigate(['/quotes/quotes-form/',LOBID,product.mstGroupID]);
  })
}
goToQuoteForm(mstGroupID){
  this.router.navigate(['/quotes/quotes-form/',mstGroupID]);
}
  logout() {
    // this.closeDropdown('dropdownButton');
    const dialogRef = this.dialog.open(MatDialogComponent, {
      panelClass: ['dialog-responsive'],
      disableClose: true,
      data: {
        yesOrNoPopup: true,
        errorMessage: this.translate.instant('Logout_Msg'),
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        window.localStorage.removeItem('Afrisure-Token');
          localStorage.removeItem('customerLogin')
        localStorage.clear();
        window.sessionStorage.clear();
        this.authService.logout();
        this.router.navigate(['/landing'])
        // if (this.orgGrpId) {
        //   this.router.navigate(['/auth/login', this.orgGrpId]);
        // }
      }
    });
  }
  
  insuranceMenuClosed:boolean = false;
  closeInsuranceMenu() {
    this.insuranceMenuClosed = true;
  }


  @ViewChild(MatMenuTrigger) menuTrigger: MatMenuTrigger;

  closeMenu() {
    if (this.menuTrigger && this.menuTrigger.menuOpen) {
      this.menuTrigger.closeMenu();
    }
  }
  loginPop(){
    // let dialogRef = this.dialog.open(MobileLoginDialogComponent, {
    //   width: '50VW',
    //   disableClose: true,
   
    // });
     let dialogRef = this.dialog.open(SignUpComponent, {
        width: '500px',
        height:'auto',
        disableClose: true,
        autoFocus:false,
        data: {
          isResultValid: true,
    
        }
      })
     
  dialogRef.afterClosed().subscribe(result => {
    if (result) {
      this.authService.login();
    }
  });
  }
  myquotes(){
    this.router.navigate(['/view/view_quotationlist'])  

    // if(this.isLogin){
    //  this.router.navigate(['/view/view_quotationlist'])  

    //  } 
    // else if (!this.isLogin){
    //   let dialogRef = this.dialog.open(SignUpComponent, {
    //     width: '45VW',
    //     height:'auto',
    //     disableClose: true,
    //     autoFocus:false,
    //     data: {
    //       isResultValid: true,
    
    //     }
    //   })
    // dialogRef.afterClosed().subscribe(result => {
    //   if (result) {
    //     this.authService.login();

    //    this.router.navigate(['/view/view_quotationlist'])  
        
    //     // history.back();
    //     // this.router.navigate(['product-config/quotation-form/',this.quotationSearchID])
    //   }
    // });
    // }

  }
  myPolicy(){
    if(this.isLogin){
      this.router.navigate(['/view/policy-list'])  
 
     } else if (!this.isLogin){
      let dialogRef = this.dialog.open(SignUpComponent, {
        width: '500px',
        height:'auto',
        disableClose: true,
        autoFocus:false,
        data: {
          isResultValid: true,
    
        }
      })
   
     dialogRef.afterClosed().subscribe(result => {
       if (result) {
        this.authService.login();

        this.router.navigate(['/view/policy-list'])  
         
         // history.back();
         // this.router.navigate(['product-config/quotation-form/',this.quotationSearchID])
       }
     });
     }
  }
  login(){
    this.router.navigate(['/auth/login'])
  }
}
